/** Shown while a lazy-loaded route chunk is downloading. */
export function RouteLoading() {
    return (
        <div className="flex min-h-[50vh] items-center justify-center bg-background">
            <div className="text-muted-foreground">Loading…</div>
        </div>
    );
}
